export type Maybe<T> = T | null
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  Object: any
}

export type GQLLocalQuery = {
  __typename?: 'Query'
  cart?: Maybe<GQLLocalCart>
  account?: Maybe<GQLLocalAccount>
  suggestFragments: Array<Maybe<Scalars['String']>>
  header: GQLLocalHeader
  ui: GQLLocalUi
  csrfToken: Scalars['String']
  watchdogAlerts: GQLLocalWatchdogAlerts
}

export type GQLLocalQueryWatchdogAlertsArgs = {
  id: Scalars['ID']
}

export type GQLLocalMutation = {
  __typename?: 'Mutation'
  addToCart?: Maybe<GQLLocalCart>
  deleteCart?: Maybe<GQLLocalCart>
  deleteCartDigital?: Maybe<GQLLocalCart>
  deleteCartWarranty?: Maybe<GQLLocalCart>
  deleteCartInsurance?: Maybe<GQLLocalCart>
  deleteReturnGuarantee?: Maybe<GQLLocalCart>
  changeAmount?: Maybe<GQLLocalCart>
  deleteAllFragments: Array<Maybe<Scalars['String']>>
  deleteFragment: Array<Maybe<Scalars['String']>>
  addFragment: Array<Maybe<Scalars['String']>>
  setHeaderVisiblity?: Maybe<GQLLocalHeader>
  setUi?: Maybe<GQLLocalUi>
  addWatchdog: GQLLocalWatchdogAlerts
  addWatchdogAvailability: GQLLocalWatchdogAlerts
}

export type GQLLocalMutationAddToCartArgs = {
  addCart: GQLLocalCartAddInput
}

export type GQLLocalMutationDeleteCartArgs = {
  cartId: Scalars['ID']
  articleId: Scalars['ID']
}

export type GQLLocalMutationDeleteCartDigitalArgs = {
  id: Scalars['ID']
  bundleId: Scalars['ID']
  cartId: Scalars['ID']
}

export type GQLLocalMutationDeleteCartWarrantyArgs = {
  articleId: Scalars['ID']
  cartId: Scalars['ID']
  variantId: Scalars['ID']
}

export type GQLLocalMutationDeleteCartInsuranceArgs = {
  articleId: Scalars['ID']
  cartId: Scalars['ID']
  variantId: Scalars['ID']
}

export type GQLLocalMutationDeleteReturnGuaranteeArgs = {
  articleId: Scalars['ID']
  cartId: Scalars['ID']
  variantId: Scalars['ID']
}

export type GQLLocalMutationChangeAmountArgs = {
  articleId: Scalars['ID']
  cartId: Scalars['ID']
  amount: Scalars['Int']
}

export type GQLLocalMutationDeleteFragmentArgs = {
  fragment?: Maybe<Scalars['String']>
}

export type GQLLocalMutationAddFragmentArgs = {
  fragment?: Maybe<Scalars['String']>
}

export type GQLLocalMutationSetHeaderVisiblityArgs = {
  isMenuVisible?: Maybe<Scalars['Boolean']>
  isSearchVisible?: Maybe<Scalars['Boolean']>
  isSearchVisibleMobileOverlay?: Maybe<Scalars['Boolean']>
  menuDesktopHiddenList?: Maybe<Scalars['Boolean']>
}

export type GQLLocalMutationSetUiArgs = {
  ui: GQLLocalUiInput
}

export type GQLLocalMutationAddWatchdogArgs = {
  input: GQLLocalAddWatchdogInput
}

export type GQLLocalMutationAddWatchdogAvailabilityArgs = {
  input: GQLLocalAddWatchdogAvailabilityInput
}

export type GQLLocalDeleteWatchdogInput = {
  id: Scalars['ID']
  type: Scalars['String']
}

export type GQLLocalAddWatchdogAvailabilityInput = {
  id: Scalars['ID']
  route: Scalars['String']
}

export type GQLLocalAddWatchdogInput = {
  id: Scalars['ID']
  targetValue: Scalars['String']
}

export type GQLLocalWatchdogAlerts = {
  __typename?: 'WatchdogAlerts'
  id: Scalars['ID']
  AV?: Maybe<GQLLocalWatchdogAlertsAv>
  PR?: Maybe<GQLLocalWatchdogAlertsPr>
}

export type GQLLocalWatchdogAlertsAv = {
  __typename?: 'WatchdogAlertsAv'
  type: Scalars['String']
  watchdogId: Scalars['String']
  id: Scalars['ID']
}

export type GQLLocalWatchdogAlertsPr = {
  __typename?: 'WatchdogAlertsPr'
  targetValue: Scalars['String']
  type: Scalars['String']
  id: Scalars['ID']
  watchdogId: Scalars['String']
}

export type GQLLocalCart = {
  __typename?: 'Cart'
  id: Scalars['ID']
  cartId?: Maybe<Scalars['String']>
  amount: GQLLocalCartAmount
  price: GQLLocalCartPrice
  articles: Array<GQLLocalCartArticle>
  /** marketplacePartners should be type of { [key: string]: CartMarketplacePartner } */
  marketplacePartners: Scalars['Object']
  action: GQLLocalCartAction
  webSocket: GQLLocalCartWebsocket
}

export type GQLLocalCartWebsocket = {
  __typename?: 'CartWebsocket'
  articleId: Scalars['String']
}

export type GQLLocalCartAction = {
  __typename?: 'CartAction'
  action: Scalars['String']
  amount: Scalars['Int']
}

export type GQLLocalCartAvailability = {
  __typename?: 'CartAvailability'
  inStock: Scalars['Int']
  stock: GQLLocalCartAvailabilityStock
}

export type GQLLocalCartAvailabilityStock = {
  __typename?: 'CartAvailabilityStock'
  translationKey: Scalars['String']
}

export type GQLLocalCartArticle = {
  __typename?: 'CartArticle'
  articleId: Scalars['ID']
  title: Scalars['String']
  simpleTitle: Scalars['String']
  availabilityKeyTranslated: Scalars['String']
  createTime: Scalars['Int']
  articleType: Scalars['String']
  availabilityKey: Scalars['String']
  count: Scalars['Int']
  mainMediaId?: Maybe<Scalars['Int']>
  marketplacePartner: GQLLocalCartMarketplacePartner
  params?: Maybe<Array<GQLLocalCartArticleParam>>
  price: GQLLocalCartArticlePrice
  product: GQLLocalCartArticleProduct
  bundleId: Scalars['ID']
  bundles: GQLLocalCartArticleBundles
  availability: GQLLocalCartAvailability
  variants?: Maybe<Array<GQLLocalCartArticleVariants>>
  url: Scalars['String']
  hasGift: Scalars['Boolean']
}

export type GQLLocalCartMarketplacePartner = {
  __typename?: 'CartMarketplacePartner'
  id: Scalars['ID']
  title: Scalars['String']
  url?: Maybe<Scalars['String']>
}

export type GQLLocalCartArticleParam = {
  __typename?: 'CartArticleParam'
  css: Scalars['String']
  key: Scalars['String']
  title: Scalars['String']
  value: Scalars['String']
}

export type GQLLocalCartArticleVariants = {
  __typename?: 'CartArticleVariants'
  id: Scalars['Int']
  variantId: Scalars['Int']
  title: Scalars['String']
  itemId: Scalars['Int']
}

export type GQLLocalCartArticleProduct = {
  __typename?: 'CartArticleProduct'
  urlKey: Scalars['String']
}

export type GQLLocalCartArticlePrice = {
  __typename?: 'CartArticlePrice'
  actual: Scalars['Float']
  type: Scalars['String']
}

export type GQLLocalCartPrice = {
  __typename?: 'CartPrice'
  total: Scalars['Int']
  base: Scalars['Int']
  vat: Scalars['Int']
}

export type GQLLocalCartAmount = {
  __typename?: 'CartAmount'
  articles: Scalars['Int']
  pieces: Scalars['Int']
}

export type GQLLocalCartArticleBundles = {
  __typename?: 'CartArticleBundles'
  digital: Array<GQLLocalCartArticleBundlesDigital>
  warranty: Array<GQLLocalCartArticleBundlesWarranty>
  insurance: Array<GQLLocalCartArticleBundlesInsurance>
  returnGuarantee: Array<GQLLocalCartArticleBundlesReturnGuarantee>
}

export type GQLLocalCartArticleBundlesDigital = {
  __typename?: 'CartArticleBundlesDigital'
  id: Scalars['ID']
  title: Scalars['String']
  active: Scalars['Boolean']
  actualPrice: Scalars['Float']
  rrpPrice: Scalars['Float']
  originalPrice: Scalars['Float']
  variantId: Scalars['String']
  itemId: Scalars['String']
}

export type GQLLocalCartArticleBundlesWarranty = {
  __typename?: 'CartArticleBundlesWarranty'
  id: Scalars['ID']
  type: Scalars['String']
  active: Scalars['Boolean']
  actualPrice: Scalars['Float']
  variantId: Scalars['String']
  itemId: Scalars['String']
}

export type GQLLocalCartArticleBundlesInsurance = {
  __typename?: 'CartArticleBundlesInsurance'
  id: Scalars['ID']
  type: Scalars['String']
  active: Scalars['Boolean']
  actualPrice: Scalars['Float']
  variantId: Scalars['String']
  itemId: Scalars['String']
}

export type GQLLocalCartArticleBundlesReturnGuarantee = {
  __typename?: 'CartArticleBundlesReturnGuarantee'
  id: Scalars['ID']
  type: Scalars['String']
  active: Scalars['Boolean']
  actualPrice: Scalars['Float']
  variantId: Scalars['String']
  itemId: Scalars['String']
}

export type GQLLocalCartAddBundlesInput = {
  digital: Array<Maybe<Scalars['String']>>
  warranty: Array<Maybe<Scalars['String']>>
  insurance: Array<Maybe<Scalars['String']>>
  returnGuarantee: Array<Maybe<Scalars['String']>>
}

export type GQLLocalCartAddInput = {
  variantId?: Maybe<Scalars['ID']>
  count: Scalars['Int']
  itemId?: Maybe<Scalars['ID']>
  amount: Scalars['Int']
  bundles: GQLLocalCartAddBundlesInput
  context?: Maybe<Scalars['String']>
  billingMethodId?: Maybe<Scalars['String']>
  bonusSetId?: Maybe<Scalars['String']>
}

export enum GQLLocalOpenHeaderEnum {
  Cart = 'CART',
  WishList = 'WISH_LIST',
  User = 'USER',
}

export type GQLLocalUiInput = {
  isLoginInProgress?: Maybe<Scalars['Boolean']>
  openHeaderTab?: Maybe<GQLLocalOpenHeaderEnum>
  openAdultConfirm?: Maybe<Scalars['Boolean']>
  openGlossaryTerm?: Maybe<Scalars['String']>
  mpPanelTranslationKey?: Maybe<Scalars['String']>
  openVideoUrl?: Maybe<Scalars['String']>
}

export type GQLLocalUi = {
  __typename?: 'Ui'
  isLoginInProgress: Scalars['Boolean']
  showLoginModal: Scalars['Boolean']
  showSelectCardModal: Scalars['Boolean']
  openHeaderTab: GQLLocalOpenHeaderEnum
  openAdultConfirm: Scalars['Boolean']
  openGlossaryTerm: Scalars['String']
  mpPanelTranslationKey: Scalars['String']
  openVideoUrl: Scalars['String']
  hideSidebar: Scalars['Boolean']
  openAddCart: Scalars['String']
  openMallSmartInfo: Scalars['Boolean']
}

export type GQLLocalAccount = {
  __typename?: 'Account'
  id: Scalars['ID']
  isAuth: Scalars['Boolean']
  isLogged: Scalars['Boolean']
  isNewCustomer?: Maybe<Scalars['Boolean']>
  isLoggedAsEmployee?: Maybe<Scalars['Boolean']>
  isInternal?: Maybe<Scalars['Boolean']>
  gtmCustomerId?: Maybe<Scalars['String']>
  customer?: Maybe<GQLLocalAccountCustomer>
  consents?: Maybe<GQLLocalAccountConsents>
}

export type GQLLocalCustomerYottly = {
  __typename?: 'CustomerYottly'
  id: Scalars['String']
}

export type GQLLocalAccountCustomer = {
  __typename?: 'AccountCustomer'
  firstname: Scalars['String']
  lastname: Scalars['String']
  email: Scalars['String']
  phone: Scalars['String']
  id: Scalars['ID']
  partnerId: Scalars['ID']
  yottly: GQLLocalCustomerYottly
  vipType: Scalars['String']
  gtmCustomerId: Scalars['String']
}

export type GQLLocalAccountConsents = {
  __typename?: 'AccountConsents'
  gdprPanel: Scalars['Boolean']
  gdprPersonalization: Scalars['Boolean']
  gdprRemarketing: Scalars['Boolean']
}

export type GQLLocalHash = {
  __typename?: 'Hash'
  hash: Scalars['String']
}

export type GQLLocalHeader = {
  __typename?: 'Header'
  menuIsVisible: Scalars['Boolean']
  searchIsVisible: Scalars['Boolean']
  menuDesktopHiddenList: Scalars['Boolean']
  searchIsVisibleMobileOverlay: Scalars['Boolean']
}
